(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('whalebud-footer-mobile-layout')) {
    customElements.define(
      'whalebud-footer-mobile-layout',
      class WhalebudFooterMobileLayout extends HTMLElement {
        connectedCallback() {
          this.mobileMedia = window.matchMedia('(max-width: 749px)');
          this.records = [];
          this.generatedSlots = [];
          this.activeSlots = {};
          this.handleViewportChange = this.applyLayout.bind(this);
          this.handleSectionLoad = this.applyLayout.bind(this);

          this.querySelectorAll('[data-whalebud-footer-block-type="newsletter"], [data-whalebud-footer-block-type="social"]').forEach((item) => {
            const anchor = document.createComment(`whalebud-footer-${item.dataset.whalebudFooterBlockType}`);
            item.before(anchor);
            this.records.push({ item, anchor, type: item.dataset.whalebudFooterBlockType });
          });

          if (this.mobileMedia.addEventListener) {
            this.mobileMedia.addEventListener('change', this.handleViewportChange);
          } else {
            this.mobileMedia.addListener(this.handleViewportChange);
          }
          document.addEventListener('shopify:section:load', this.handleSectionLoad);
          this.applyLayout();
        }

        disconnectedCallback() {
          this.restoreItems();
          this.generatedSlots.forEach((slot) => slot.remove());
          if (this.mobileMedia?.removeEventListener) {
            this.mobileMedia.removeEventListener('change', this.handleViewportChange);
          } else {
            this.mobileMedia?.removeListener(this.handleViewportChange);
          }
          document.removeEventListener('shopify:section:load', this.handleSectionLoad);
        }

        createSlot(promo, type) {
          const slot = document.createElement('ul');
          slot.className = `whalebud-footer-mobile-slot whalebud-footer-mobile-slot--${type} list-unstyled`;
          slot.dataset.whalebudFooterMobileSlot = type;
          slot.hidden = true;

          if (type === 'newsletter') {
            promo.before(slot);
          } else {
            promo.after(slot);
          }
          this.generatedSlots.push(slot);
          return slot;
        }

        getSlots(createMissing = false) {
          const footer = this.closest('.footer');
          if (!footer) return {};

          const precedingPromos = Array.from(document.querySelectorAll('.whalebud-footer-promo')).filter(
            (promo) => promo.compareDocumentPosition(footer) & Node.DOCUMENT_POSITION_FOLLOWING
          );
          const promo = precedingPromos[precedingPromos.length - 1];
          const promoSection = promo?.closest('.shopify-section') || promo?.parentElement;
          if (!promo || !promoSection) return {};

          let newsletter = promoSection.querySelector('[data-whalebud-footer-mobile-slot="newsletter"]');
          let social = promoSection.querySelector('[data-whalebud-footer-mobile-slot="social"]');
          if (createMissing && !newsletter) newsletter = this.createSlot(promo, 'newsletter');
          if (createMissing && !social) social = this.createSlot(promo, 'social');

          return {
            newsletter,
            social,
          };
        }

        copyColorScheme(slot) {
          const footer = this.closest('.footer');
          if (!footer || !slot) return;
          Array.from(slot.classList)
            .filter((className) => className.startsWith('color-'))
            .forEach((className) => slot.classList.remove(className));
          const colorScheme = Array.from(footer.classList).find((className) => className.startsWith('color-'));
          if (colorScheme) slot.classList.add(colorScheme);
          slot.classList.toggle('gradient', footer.classList.contains('gradient'));
        }

        restoreItems() {
          this.records.forEach(({ item, anchor }) => {
            if (anchor.parentNode) anchor.parentNode.insertBefore(item, anchor.nextSibling);
          });
          const slots = Object.keys(this.activeSlots).length ? this.activeSlots : this.getSlots();
          if (slots.newsletter) slots.newsletter.hidden = true;
          if (slots.social) slots.social.hidden = true;
          this.activeSlots = {};
        }

        applyLayout() {
          if (!this.mobileMedia?.matches) {
            this.restoreItems();
            return;
          }

          const slots = this.getSlots(true);
          this.activeSlots = slots;
          this.records.forEach(({ item, type }) => {
            const slot = slots[type];
            if (!slot) return;
            this.copyColorScheme(slot);
            slot.hidden = false;
            slot.appendChild(item);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-tabbar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('page-tabbar')) {
    customElements.define('page-tabbar', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('.page-tabbar');
        this.links = Array.from(this.querySelectorAll('.page-tabbar-link'));
        this.header = document.querySelector('.section-header');
        this.queueUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };
        this.onClick = this.scrollToTarget.bind(this);
        this.addEventListener('click', this.onClick);
        window.addEventListener('scroll', this.queueUpdate, { passive: true });
        window.addEventListener('resize', this.queueUpdate);
        document.addEventListener('shopify:section:load', this.queueUpdate);
        document.addEventListener('shopify:section:unload', this.queueUpdate);
        document.addEventListener('shopify:section:reorder', this.queueUpdate);
        this.resizeObserver = new ResizeObserver(this.queueUpdate);
        this.resizeObserver.observe(this.bar);
        this.resizeObserver.observe(document.body);
        if (this.header) {
          this.resizeObserver.observe(this.header);
          this.headerObserver = new MutationObserver(this.queueUpdate);
          this.headerObserver.observe(this.header, { attributes: true, attributeFilter: ['class'] });
        }
        this.queueUpdate();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        window.removeEventListener('scroll', this.queueUpdate);
        window.removeEventListener('resize', this.queueUpdate);
        document.removeEventListener('shopify:section:load', this.queueUpdate);
        document.removeEventListener('shopify:section:unload', this.queueUpdate);
        document.removeEventListener('shopify:section:reorder', this.queueUpdate);
        this.resizeObserver.disconnect();
        this.headerObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      headerHeight() {
        const type = this.header?.querySelector('sticky-header')?.dataset.stickyType;
        return type && type !== 'none' ? this.header.offsetHeight : 0;
      }

      targets() {
        return this.links.map(link => ({
          link,
          target: document.getElementById(link.dataset.target)
        })).filter(item => item.target);
      }

      setActive(link) {
        if (this.activeLink === link) return;
        this.activeLink = link;
        this.links.forEach(item => {
          if (item === link) item.setAttribute('aria-current', 'location');
          else item.removeAttribute('aria-current');
        });
        if (link) {
          const inner = this.querySelector('.page-tabbar-inner');
          inner.scrollTo({ left: link.offsetLeft - inner.offsetLeft - (inner.clientWidth - link.offsetWidth) / 2 });
        }
      }

      update() {
        const top = this.header?.classList.contains('shopify-section-header-hidden') ? 0 : this.headerHeight();
        const height = this.bar.offsetHeight;
        this.style.height = `${height}px`;
        this.style.setProperty('--tabbar-top', `${top}px`);
        this.classList.toggle('is-sticky', this.getBoundingClientRect().top <= top);
        const items = this.targets();
        let active = items[0]?.link;
        items.forEach(item => {
          if (item.target.getBoundingClientRect().top <= top + height + 2) active = item.link;
        });
        if (window.scrollY > 0 && window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2) {
          active = items[items.length - 1]?.link;
        }
        this.setActive(active);
      }

      scrollToTarget(event) {
        const link = event.target.closest('.page-tabbar-link');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.dataset.target);
        if (!target) return;
        event.preventDefault();
        const type = this.header?.querySelector('sticky-header')?.dataset.stickyType;
        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        const goingUp = targetTop - this.bar.offsetHeight - this.headerHeight() < window.scrollY;
        const headerOffset = goingUp || type === 'always' || type === 'reduce-logo-size' ? this.headerHeight() : 0;
        window.scrollTo({
          top: Math.max(0, targetTop - this.bar.offsetHeight - headerOffset),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
